import request from './request'
import {getCookie} from "@/helpers";

const getOffersReports = async (data) =>{
  try {

    let preparedFilters = ''

    for (const filter in data.filters) {
      preparedFilters += (!!data.filters[filter]) ?
          `${filter}: "'${data.filters[filter]}'"` : ''
    }
    const result = await request.post(`/graphql`, {
          query: `
            {
              reports(
                groupBy:"${data.groupBy}",
                pagination: {
                  page: ${data.page},
                  limit: ${data.limit},
                },
                sorting: {
                  orderBy: "${data.orderBy}",
                  orderDirectionAsc: ${data.orderDirectionAsc},
                },
                filter:{${preparedFilters}},
                period:{
                start: ${data.fromDate},
                end:${data.toDate},
                }
                ){
                  count, 
                  data {
                    drill_down,
                    tags,
                    offer,
                    offer_id,
                    advertiser,
                    acc_manager,
                    clicks,
                    conversions,
                    installations,
                    sales, 
                    conversion,
                    epc,
                    avg_cost,
                    cost,
                    revenue,
                    margin,
                    profit
                  }
                }
            }
          `
        },
        {
          headers: {
            'Authorization': getCookie('accessToken'),
            'Referrer-Police': 'strict-origin-when-cross-origin',
            'Access-Control-Allow-Origin': '*',
            'workspace': localStorage.getItem('workspace')
          }
        }
    )

    return {
      statuses: result.data.data.reports,
      entity: data.entity
    }

  } catch (err) {
    console.error(err)
  }
}

const getCampaignsReports = async (data) =>{
  try {

    let preparedFilters = ''

    for (const filter in data.filters) {
      preparedFilters += (!!data.filters[filter]) ?
          `${filter}: "'${data.filters[filter]}'"` : ''
    }
    const result = await request.post(`/graphql`, {

          query: `
            {
              reports(
                groupBy:"${data.groupBy}",
                pagination: {
                  page: ${data.page},
                  limit: ${data.limit},
                },
                sorting: {
                  orderBy: "${data.groupBy}",
                  orderDirectionAsc: ${data.orderDirectionAsc},
                },
                filter:{${preparedFilters}},
                period:{
                start: ${data.fromDate},
                end:${data.toDate},
                }
                ){
                  drill_down,
                  tags,
                  campaign,
                  campaign_id,
                  vertical_name,
                  img,
                  kw,
                  advertiser,
                  acc_manager,
                  clicks,
                  conversions,
                  installations,
                  sales,
                  conversion,
                  epc,
                  avg_cost,
                  cost,
                  revenue,
                  margin,
                  profit
                }
              }
          `
        },
        {
          headers: {
            'Authorization': getCookie('accessToken'),
            'Referrer-Police': 'strict-origin-when-cross-origin',
            'Access-Control-Allow-Origin': '*',
            'workspace': localStorage.getItem('workspace')
          }
        }
    )

    return {
      statuses: result.data.data.reports,
      entity: data.entity
    }

  } catch (err) {
    console.error(err)
  }
}

/**
 *
 * @param data {
 *    filter: [{field: string, value: string}],
 *    groupBy: string,
 *    sorting: {orderBy: string, orderDirectionAsc: boolean},
 *    select: [string],
 *    period: {start: string, end: string},
 *    pagination: {page: int, limit: int}
 *  }
 * @returns {Promise<{drillDownId, statuses: ([]|*), drillDownType: (default.methods.drillDown.value|*), entity}>}
 */
const getDrillDownReports = async (data) =>{
  console.log('getDrillDownReports')
  // console.log(`data entity ${JSON.stringify(data.entity)} `, )
  // console.log(`data filter 1 ${JSON.stringify(data.filter)} `, )
  try {
    let preparedFilter = []
    if (data.filter) {
      for (let i = 0; i < data.filter.length; i++) {
        if (!!data.filter[i] && data.filter[i].value) {
          let value;
          if (typeof data.filter[i].value === 'object' && data.filter[i].value.length) {
            value = data.filter[i].value.map(v => `"${v}"`);
          } else if (typeof data.filter[i].value !== 'object' && data.filter[i].value) {
            value = `"${data.filter[i].value}"`;
          }

          if (value) {
            let operator = data.filter[i].operator ? `, operator: "${data.filter[i].operator}"` : '';
            preparedFilter.push(
                `{ field: "${data.filter[i].field}", value: [${value}]${operator} }`
            );
          }
        }
      }
    }

    data.filter = preparedFilter ? `filter:[${preparedFilter.join(',')}]` : ''

    console.log(`[DATA] ${JSON.stringify(data)} `)
    // console.log(`[FILTER] ${JSON.stringify(data.filter)} `)
    // console.log(`[GROUP_BY] ${JSON.stringify(data.groupBy)} `)
    // console.log(`[fromDate] ${JSON.stringify(data.fromDate)} `)
    // console.log(`[toDate] ${JSON.stringify(data.toDate)} `)
    const comparedPeriod =
        (data.fromDateComp && data.fromDateComp !== 0 && data.toDateComp && data.toDateComp !== 0) ? `
      periodComp:{
        start: ${data.fromDateComp},
        end:${data.toDateComp},
      },` : '';

    const comparedData = data.isCompared ? `
      comparedData{${data.entity}, ${data.groupBy}, ${data.select ? data.select.join(',') + ',' : ''}}
    ` : '';

    const result = await request.post(`/graphql`, {
          query: `
            {
              reports(
                select: [
                  ${data.select ? `"${data.select.join('","')}",` : ''}
                ],
                groupBy:"${data.groupBy}",
                pagination: {
                  page: ${data.page},
                  limit: ${data.limit},
                },
                sorting: {
                  orderBy: "${data.orderBy}",
                  orderDirectionAsc: ${data.orderDirectionAsc},
                  orderDirs: "${data.orderDirs || ''}"
                },
                ${data.filter},
                period:{
                  start: ${data.fromDate},
                  end: ${data.toDate},
                },
                ${comparedPeriod}
                onlyAggregatedStats: ${!!data.onlyAggregatedStats},
                drillDownType: "${data.drillDownType}",
                isChart: ${data.isChart}
                platform: ${data.platform || 1}
                version: "${data.version || 'V1'}"
                timezone: "${data.timezone || 'UTC'}"
                conversionFocused: ${!!data.conversionFocused}
                isExporting: ${!!data.isExporting}
                ${data.exportFields && data.exportFields.length > 0 
                  ? `exportFields: [${data.exportFields.map(f => `{column: "${f.column}", alias: "${f.alias}"}`).join(', ')}]`
                  : ''
                }
                ${data.breakdownBy ? `breakdownBy: "${data.breakdownBy}"` : ''}
              ) {
                  count,
                  speed,
                  isFromCache,
                  message,
                  data {
                    ${data.entity},
                    ${data.groupBy},
                    ${data.select ? data.select.join(',') + ',' : ''},
                    ${comparedData}
                  },
                  totals{
                    total_uvs,
                    total_clicks,
                    total_profit,
                    total_margin,
                    total_revenue,
                    total_impressions,
                    total_registrations,
                    total_conversions,
                    total_total_paid,
                    total_installations,
                    total_sales,
                    total_cost,
                    avg_epc,
                    total_avg_cost, 
                    total_sales_ratio, 
                    total_uvs_sales_ratio
                  },
                  totalsComp{
                    total_uvs,
                    total_clicks,
                    total_profit,
                    total_margin,
                    total_revenue,
                    total_impressions,
                    total_registrations,
                    total_conversions,
                    total_total_paid,
                    total_installations,
                    total_sales,
                    total_cost,
                    avg_epc,
                    total_avg_cost, 
                    total_sales_ratio, 
                    total_uvs_sales_ratio
                  },
                }
            }
          `
        },
        {
          headers: {
            'Authorization': getCookie('accessToken'),
            'Referrer-Police': 'strict-origin-when-cross-origin',
            'Access-Control-Allow-Origin': '*',
            'workspace': localStorage.getItem('workspace')
          }
        }
    )


    if(result.data.errors) {
      throw new Error(result.data.errors[0].message)
    }

    return {
      statuses: result.data.data.reports,
      entity: data.entity,
      drillDownId: data.id,
      drillDownType: data.drillDownType,
      fromDate: data.fromDate,
      toDate: data.toDate
    }

  } catch (err) {
    console.error(err)
    throw err;
  }
}

const getChartReports = async (data) =>{
  console.log('getChartReports')

  // console.log(`data filter ${JSON.stringify(data.filter)} `, )
  try {
    let preparedFilter = []
    if(data.filter) {
      for (let i = 0; i < data.filter.length; i++) {
        if (!!data.filter[i] && data.filter[i].value) {
          let value;
          if (typeof data.filter[i].value === 'object' && data.filter[i].value.length) {
            value = data.filter[i].value.map(v => `"${v}"`)
          } else if (typeof data.filter[i].value !== 'object' && data.filter[i].value) {
            value = `"${data.filter[i].value}"`
          }
          if (value) {
            let operator = data.filter[i].operator ? `, operator: "${data.filter[i].operator}"` : '';
            preparedFilter.push(
                `{ field: "${data.filter[i].field}", value: [${value}]${operator} }`
            );
          }
        }
      }
    }
    data.filter = preparedFilter ? `filter:[${preparedFilter.join(',')}]` : ''
    // console.log(`data filter ready  ${JSON.stringify(data.filter)} `, )
    const comparedPeriod = (data.fromDateComp !== 0 && data.toDateComp !== 0) ? `
      periodComp:{
        start: ${data.fromDateComp},
        end:${data.toDateComp},
      },` : '';

    const compDates = (data.fromDateComp !== 0 && data.toDateComp !== 0) ? 'compDates' : '';

    const result = await request.post(`/graphql`, {
          query: `
            {
              chartReport(
                select: [
                  ${data.select ? `"${data.select.join('","')}",` : ''}
                ],
                groupBy:"${data.groupBy}",
                 pagination: {
                  page: ${data.page},
                  limit: ${data.limit},
                },
                sorting: {
                  orderBy: "${data.orderBy}",
                  orderDirectionAsc: ${data.orderDirectionAsc},
                },
                ${data.filter},
                period:{
                  start: ${data.fromDate},
                  end: ${data.toDate},
                },
                platform: ${data.platform}
                version: "${data.version || 'V1'}"
                ${comparedPeriod}
                onlyAggregatedStats: ${!!data.onlyAggregatedStats},
                drillDownType: "${data.drillDownType}",
                timezone: "${data.timezone || 'UTC'}",
                ){
                  comparedData{
                    ${data.entity},
                    ${data.groupBy},
                    ${data.select ? data.select.join(',') + ',' : ''}
                  }
                  data{
                    ${data.entity},
                    ${data.groupBy},
                    ${data.select ? data.select.join(',') + ',' : ''}
                  }
                  dates
                  ${compDates}
                }
            }
          `
        },
        {
          headers: {
            'Authorization': getCookie('accessToken'),
            'Referrer-Police': 'strict-origin-when-cross-origin',
            'Access-Control-Allow-Origin': '*',
            'workspace': localStorage.getItem('workspace')
          }
        }
    )


    if(result.data.errors) {
      throw new Error(result.data.errors[0].message)
    }

    if (data.fromDateComp !== 0 && data.toDateComp !== 0) {
      return {
        drillDownId: data.id,
        comparedData: result.data.data.chartReport.comparedData,
        data: result.data.data.chartReport.data,
        dates: result.data.data.chartReport.dates,
        compDates: result.data.data.chartReport.compDates
      }
    }

    return {
      drillDownId: data.id,
      data: result.data.data.chartReport.data,
      dates: result.data.data.chartReport.dates,
    }

  } catch (err) {
    console.error(err)
    throw err;
  }
}

const getMainFilterData = async (data) => {
  try {
    let preparedFilter = []
    if(data.filter) {
      for (let i = 0; i < data.filter.length; i++) {
        preparedFilter.push(
            (!!data.filter[i]) ? `{ field: "${data.filter[i].field}", value: "${data.filter[i].value}" }` : ''
        )
      }
    }

    data.filter = (preparedFilter && preparedFilter.length > 0) ? `filter:[${preparedFilter.join(',')}],` : ''

    const result = await request.post(`/graphql`, {
          query: `
            {
              reportNamesIds(
                ${data.filter}
                period:{
                  start: ${data.fromDate},
                  end: ${data.toDate},
                },
                groupBy:"${data.groupBy}"
              )
              {
                id,
                ${data.entity}
              }
            }
          `
        },
        {
          headers: {
            'Authorization': getCookie('accessToken'),
            'Referrer-Police': 'strict-origin-when-cross-origin',
            'Access-Control-Allow-Origin': '*',
            'workspace': localStorage.getItem('workspace')
          }
        }
    )

    if(result.data.errors) {
      throw new Error(result.data.errors[0].message)
    }

    return {
      data: result.data.data.reportNamesIds,
      entity: data.entity,
      drillDownId: data.id,
      drillDownType: data.drillDownType
    }
  } catch (err) {
    console.error(err)
    throw err;
  }
}

const getFilter = async (data) => {
  let preparedFilter = []
  if(data.filter) {
    for (let i = 0; i < data.filter.length; i++) {
      preparedFilter.push(
          (!!data.filter[i]) ? `{ field: "${data.filter[i].field}", value: [${data.filter[i].value.map(v => `"${v}"`)}] }` : ''
      )
    }
  }

  const buildBreadCrumbsArg = (crumbs = []) => {
    if (!Array.isArray(crumbs) || crumbs.length === 0) return '';
    const parts = crumbs.map(c =>
        `{ field: "${c.field}", value: "${String(c.value)}", name: "${String(c.name).replace(/"/g, '\\"')}" }`
    );
    return `breadCrumbs:[${parts.join(',')}]`;
  };
  const breadCrumbsArg = buildBreadCrumbsArg(data.breadCrumbs);

  data.filter = preparedFilter ? `filter:[${preparedFilter.join(',')}]` : ''

  const result = await request.post(`/graphql`, {
        query: `
          {
            reportFilterData(
              name: "${data.name}", 
              searchFilter: "${data.searchFilter || ''}",
              period:{
                start: ${data.fromDate},
                end: ${data.toDate},
              },
              groupBy:"${data.groupBy}",
              ${data.filter},
              ${breadCrumbsArg}
              onlyAggregatedStats: ${data.onlyAggregatedStats || false},
              drillDownType: "${data.drillDownType}"
              platform: ${data.platform}
              version: "${data.version || 'V1'}"
            ) 
            {
              key
              value
            }
          }
        `
      },
      {
        headers: {
          'Authorization': getCookie('accessToken'),
          'Referrer-Police': 'strict-origin-when-cross-origin',
          'Access-Control-Allow-Origin': '*',
          'workspace': localStorage.getItem('workspace') || 'ac'
        }
      }
  )

  if(result.status === 200) {
    const prettyData = {};
    if(result.data.data.reportFilterData) {
      const resData = result.data.data.reportFilterData;
      const obj = {};
      obj[data.name] = resData;

      return obj;
    }
  }
}

export default {
  getOffersReports,
  getCampaignsReports,
  getDrillDownReports,
  getChartReports,
  getMainFilterData,
  getFilter
}
